var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import * as React from 'react';
import classNames from 'classnames';
import omit from 'lodash/omit';
import AnimateHeight from 'react-animate-height';

import IconCaretDown from '../../icons/general/IconCaretDown';
import PlainButton from '../plain-button';
import { nines } from '../../styles/variables';
import { RESIN_TAG_TARGET } from '../../common/variables';

import './Collapsible.scss';

var Collapsible = function (_React$Component) {
    _inherits(Collapsible, _React$Component);

    function Collapsible(props) {
        _classCallCheck(this, Collapsible);

        var _this = _possibleConstructorReturn(this, (Collapsible.__proto__ || Object.getPrototypeOf(Collapsible)).call(this, props));

        _this.toggleVisibility = function () {
            var _this$props = _this.props,
                onOpen = _this$props.onOpen,
                onClose = _this$props.onClose;

            _this.setState(function (prevState) {
                return {
                    isOpen: !prevState.isOpen
                };
            }, function () {
                var isOpen = _this.state.isOpen;

                if (isOpen && onOpen) {
                    onOpen(_this);
                } else if (!isOpen && onClose) {
                    onClose(_this);
                }
            });
        };

        _this.state = {
            isOpen: props.isOpen
        };
        return _this;
    }

    _createClass(Collapsible, [{
        key: 'render',
        value: function render() {
            var isOpen = this.state.isOpen;
            var _props = this.props,
                animationDuration = _props.animationDuration,
                _props$buttonProps = _props.buttonProps,
                buttonProps = _props$buttonProps === undefined ? {} : _props$buttonProps,
                children = _props.children,
                className = _props.className,
                isBordered = _props.isBordered,
                hasStickyHeader = _props.hasStickyHeader,
                headerActionItems = _props.headerActionItems,
                title = _props.title;


            var sectionClassName = classNames('collapsible-card', {
                'is-open': isOpen
            }, {
                'is-bordered': isBordered
            }, className);
            var interactionTarget = buttonProps[RESIN_TAG_TARGET];
            var modifiedButtonProps = omit(buttonProps, [RESIN_TAG_TARGET]);
            var buttonClassName = hasStickyHeader ? 'collapsible-card-header has-sticky-header' : 'collapsible-card-header';

            if (interactionTarget) {
                modifiedButtonProps[RESIN_TAG_TARGET] = '' + interactionTarget + (isOpen ? 'collapse' : 'expand');
            }

            return React.createElement(
                'div',
                { className: sectionClassName },
                React.createElement(
                    'div',
                    { className: buttonClassName },
                    React.createElement(
                        PlainButton,
                        _extends({}, modifiedButtonProps, {
                            type: 'button',
                            onClick: this.toggleVisibility,
                            className: 'collapsible-card-title'
                        }),
                        title,
                        React.createElement(IconCaretDown, {
                            className: 'collapsible-card-header-caret',
                            color: nines,
                            width: 8
                        })
                    ),
                    isOpen && headerActionItems
                ),
                React.createElement(
                    AnimateHeight,
                    {
                        duration: animationDuration,
                        height: isOpen ? 'auto' : 0
                    },
                    React.createElement(
                        'div',
                        { className: 'collapsible-card-content' },
                        children
                    )
                )
            );
        }
    }]);

    return Collapsible;
}(React.Component);

Collapsible.defaultProps = {
    buttonProps: {},
    className: '',
    isOpen: true,
    animationDuration: 100
};
Collapsible.propTypes = {
    /** Duration of animation (milliseconds) */
    animationDuration: PropTypes.number,

    /** Other props (e.g. resin target names) to be included in the button */
    buttonProps: PropTypes.object,

    /** Content to be displayed in the card if it's expanded */
    children: PropTypes.node.isRequired,

    /** CSS class for the wrapper div */
    className: PropTypes.string,

    /** Determines look of component */
    isBordered: PropTypes.bool,

    /** Determines stickiness of the header */
    hasStickyHeader: PropTypes.bool,

    /** Determines optional header action items */
    headerActionItems: PropTypes.node,

    /** Initial state of the collapsible card */
    isOpen: PropTypes.bool.isRequired,

    /** callback called when collapsible is opened */
    onOpen: PropTypes.func,

    /** callback called when collapsible is collapsed */
    onClose: PropTypes.func,

    /** Title string or component */
    title: PropTypes.oneOfType([PropTypes.string, PropTypes.node]).isRequired
};


export default Collapsible;
import PropTypes from 'prop-types';